module.exports = __webpack_public_path__ + "img/img_slide_5.b94c27f2.webp";